import { createTheme } from '@mui/material';

export const theme = createTheme({
    typography: {
        fontFamily: ['Rubik'].join(','),
    },
    palette: {
        primary: {
            main: '#05BBC9',
            dark: '#2E3033',
        },
        secondary: {
            main: '#97A5A8',
        },
        error: {
            main: '#ED4052',
        },
    },
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    color: 'primary',
                    backgroundColor: 'primary',
                    borderColor: 'primary',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    lineHeight: '18px',
                    fontSize: '12px',
                },
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    borderRadius: 7,
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    padding: '0 5px',
                    lineHeight: '18px',
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 7,
                    padding: '9px',
                    paddingRight: '0px',
                    backgroundColor: 'white',
                    minHeight: 37,
                    '& input': {
                        padding: '0px 5px',
                    },
                    '&.Mui-focused': {
                        borderColor: '#05BBC9',
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                root: {
                    fontFamily: 'inherit',
                },
                scroller: {
                    display: 'flex',
                },
                indicator: {
                    background: 'primary',
                },
            },
        },
    },
});

export default theme;